// Shared Zod helpers for app/src/schemas/*.
// Kept minimal — only patterns that recur across collections.
//
// Wire format note: Drizzle's bun-sqlite driver converts `integer mode:'timestamp'`
// columns to Date objects on select. JSON.stringify(date) → ISO string. So the
// wire shape (client receives) is a string, the runtime shape (server holds) is
// a Date. The timestamp schema accepts both and normalises to a string so
// downstream TypeScript consumers see a single, canonical wire-shape type.

import { z } from 'zod';

/**
 * Timestamp column (Drizzle `integer + mode:'timestamp'`).
 *   - Client receives ISO string (JSON.stringify of Date).
 *   - Server's in-memory row holds a Date instance.
 * Accepts both → outputs ISO string. Consumers always see `string`.
 */
export const timestampSchema = z.union([
  z.string(),
  z.date().transform((d) => d.toISOString()),
]);

/** JSON column declared as `$type<string[]>()` in Drizzle. */
export const stringArraySchema = z.array(z.string());

/** Boolean stored as integer (mode:'boolean'). Bun-sqlite gives JS booleans. */
export const booleanIntSchema = z.boolean();
